import { ReactNode } from 'react';
import { Helmet } from 'react-helmet';

import Layout from '~/components/layouts/DefaultLayout';
import Tile from '~/images/Tiles/ICP.svg';

import { Main } from './Main';

const DEFAULT_SUBTITLE =
  "Build a high quality ICP based on your team's real world results.";

type PageLayoutProps = {
  children: ReactNode;
  subtitle?: string;
  className?: string;
};

export function PageLayout({ subtitle, ...props }: PageLayoutProps) {
  return (
    <>
      <Helmet>
        <title>Ideal Customer Profile</title>
      </Helmet>
      <Layout
        title="Ideal Customer Profile"
        subtitle={subtitle || DEFAULT_SUBTITLE}
        tile={<Tile />}>
        <Main {...props} />
      </Layout>
    </>
  );
}
